import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { IUfItem } from "./uf-list.types";

@Injectable({ providedIn: "root" })
export class UfsListService {
  private _ufList$ = new BehaviorSubject<IUfItem[]>(null);

  constructor(private _http: HttpClient) {
    this.load();
  }

  private _listaUfs(): Observable<IUfItem[]> {
    return this._http.get<IUfItem[]>(
      "assets/uf-list.json"
    );
  }

  load(): void {
    this._listaUfs().subscribe((res: IUfItem[]) => {
      this._ufList$.next(this.ordenaUfs(res));
    });
  }

  ordenaUfs(values: IUfItem[]): IUfItem[] {
    return values.sort((a, b) => {
      if (a.nome < b.nome) return -1;
      if (a.nome > b.nome) return 1;
      return 0;
    });
  }

  searchUfBySigla(sigla: string): IUfItem {
    return this._ufList$.value.find((ufItem: IUfItem) => ufItem.sigla === sigla);
  }

  //
  //
  // Accessors
  get ufList$(): Observable<IUfItem[]> {
    return this._ufList$.asObservable();
  }
}
